import React from 'react';
import PropTypes from 'prop-types';

import { ListItemAvatar as MUIListItemAvatar } from '@mui/material';

export const ListItemAvatar = props => <MUIListItemAvatar {...props} />;

ListItemAvatar.propTypes = {
  classes: PropTypes.object
};

export default ListItemAvatar;
